import storage from 'store'
import { login, getInfo, logout } from '@/api/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { setToken, removeToken } from '@/utils/auth'
import notification from 'ant-design-vue/es/notification'
import * as logistics from '@/api/logistics'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {},
    cityList: [],
    cityTotalNum: 0,
    currentProjectId: null,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_CITYS: (state, info) => {
      state.cityList = info
    },
    SET_CITYSNUM: (state, info) => {
      state.cityTotalNum = info
    },
    SET_CURRENT_PROJECT_ID: (state, projectId) => {
      state.currentProjectId = projectId
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const accountNo = userInfo.accountNo.trim()
      const password = userInfo.password
      const userType = 'ADMIN'
      const loginType = 'PASSWORD'
      const device = 'PC'
      const validCode = userInfo.validCode
      const validCodeReqNo = userInfo.validCodeReqNo
      return new Promise((resolve, reject) => {
        login(
          accountNo,
          password,
          validCode,
          validCodeReqNo,
          userType,
          loginType,
          device
        )
          .then((res) => {
            window.console.log('登录成功', res)
            if (res.success) {
              setToken(res.data.token)
              commit('SET_TOKEN', res.data.token)
              storage.set(ACCESS_TOKEN, res.data.token, 7 * 24 * 60 * 60 * 1000)
              // commit('SET_TOKEN', res.token)
              resolve()
            } else {
              notification.error({
                message: res.message,
                duration: 5 * 1000,
              })
              reject(res.message)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            const user = res.data
            // 处理头像：如果为空、null、undefined 或空字符串，不设置默认头像
            // 让组件自己处理默认头像，避免 store 中处理对象类型的问题
            let avatar = user.avatar
            if (!avatar || avatar === '' || avatar === 'null' || avatar === 'undefined') {
              // 设置为空字符串，让组件中的逻辑处理默认头像
              avatar = ''
            } else {
              // 如果已经有头像，但可能是对象类型，尝试提取字符串
              if (typeof avatar === 'object' && avatar !== null) {
                let extractedUrl = avatar.default || avatar
                while (typeof extractedUrl === 'object' && extractedUrl !== null && extractedUrl.default) {
                  extractedUrl = extractedUrl.default
                }
                if (typeof extractedUrl === 'string') {
                  avatar = extractedUrl
                }
              }
            }
            if (user.roleCodes && user.roleCodes.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit('SET_ROLES', user.roleCodes)
              commit('SET_PERMISSIONS', user.permissions)
            } else {
              commit('SET_ROLES', ['ROLE_DEFAULT'])
            }
            commit('SET_NAME', user.nickName)
            commit('SET_AVATAR', avatar)
            commit('SET_INFO', user)
            resolve({ roles: user.roleCodes || ['ROLE_DEFAULT'], ...res })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
          .finally(() => {
            console.log('退出登录')
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_PERMISSIONS', [])
            commit('SET_CURRENT_PROJECT_ID', null)
            storage.remove(ACCESS_TOKEN)
            storage.remove('currentProjectId')
            removeToken()
          })
      })
    },
    // 获取运费模板 使用的省市区
    getCity({ commit, state }) {
      return new Promise((resolve, reject) => {
        logistics.cityListTree().then((res) => {
          if (res.success) {
            /**为城市数组增加前端需要的isShow */
            let totalNum = 0
            if (res.data) {
              res.data.forEach((item, index) => {
                item.isShow = true
                item.disabled = false
                item.cityNum = 0
                item.children.forEach((item1, index1) => {
                  totalNum++
                  item1.isShow = true
                  item1.disabled = false
                  item.cityNum += 1
                })
              })

              commit('SET_CITYS', res.data)
              commit('SET_CITYSNUM', totalNum)
            }
          }
        })
      })
    },
  },
}

export default user
